import { Injectable } from '@angular/core';
import { LocationComponent } from 'src/app/modules/here/components/location/location.component';
import { ModalService } from '../utl/ctrl/ctrl.service';

@Injectable({
  providedIn: 'root'
})
export class AddressService {

  constructor(
    private modal: ModalService,
  ) { }

  loc(p:string) {
    return this.modal.show({
      component: LocationComponent,
      items: {
        placeholder: p
      },
      cssClass: 'd',
		  backdropDismiss: false,
    });
  }

  line(a){
    return `${a?.line1||'No address'}${(a?.line1)?',':''} ${a?.city||''}${(a?.city)?',':''} ${a?.state||''} ${a?.address?.postalCode||''}`;
  }

  async get() {
    let a = await this.loc('Enter your address...');
    return this.line(a);
  }
}
